import {TrainingQualificationRecordModel, TrainingType} from "@/api-client";
import {ls} from "@/CultureService";

export default class TrainingTypeName{
    public static get(trainingType: TrainingType){
        const trainingTypeMap: { [id: string]: string; } = {};
        trainingTypeMap[TrainingType.Contact] = ls.Documents_Qualifications_TrainingType_Contact;
        trainingTypeMap[TrainingType.Online] = ls.Documents_Qualifications_TrainingType_Online;
        trainingTypeMap[TrainingType.Undefined] = "-";
        return trainingTypeMap[trainingType];
    }
}

